Array.prototype.forEach.call(document.body.querySelectorAll("*[data-mask]"), applyDataMask);

function applyDataMask(field) {
    var mask = field.dataset.mask.split('');
    
    // For now, this just strips everything that's not a number
    function stripMask(maskedData) {
        function isDigit(char) {
            return /\d/.test(char);
        }
        return maskedData.split('').filter(isDigit);
    }
    
    // Replace `_` characters with characters from `data`
    function applyMask(data) {
        return mask.map(function(char) {
            if (char != '_') return char;
            if (data.length == 0) return char;
            return data.shift();
        }).join('')
    }
    
    function reapplyMask(data) {
        return applyMask(stripMask(data));
    }
    
    function changed() {   
        var oldStart = field.selectionStart;
        var oldEnd = field.selectionEnd;
        
        field.value = reapplyMask(field.value);
        
        field.selectionStart = oldStart;
        field.selectionEnd = oldEnd;
    }
    
    field.addEventListener('click', changed)
    field.addEventListener('keyup', changed)
}

jQuery(document).ready(function($){
	$('.id06btn').on('click', function(){
		var id06id = $('#id06check').val();
		console.log(id06id)
		$.ajax({
			type : "get",
			url : "https://id06prod8qptp7tf.id06.se/id06/public/companies?company_registration_number=" + id06id ,
			beforeSend: function(data) {
				$('.id06checker').addClass('loading')
				$('.id06status').html('<div class="spinner"></div>')
				console.log('loading')
			},
			success: function( data ) {
				console.log(data)
				var regno = data.company_registration_number
				var status = data.company_status
				var cards = data.active_cards
				var statusTxt = '0'
				if(status == 'active') {
					$('.id06checker').addClass('active')
					statusTxt = 'Anslutet'
				}
				$('.id06id').html(regno)
				$('.id06status').html(statusTxt + ' (' + cards + ' kort)');
				$('.id06checker').removeClass('loading')
			},
			error: function( err ) {
				$('.id06checker').addClass('not_active')
				$('.id06id').html(id06id)
				$('.id06status').html('Ej anslutet');
			}
  		});
	});
});